module.exports = __webpack_public_path__ + "static/media/astrazeneca.50002757.png";